export const totalTitle = 'Total:';
export const canContinueShopping = false;